import { createDynamicThunk } from ".";

export const getExpenseListThunk = createDynamicThunk({
  typePrefix: "expenses/getExpenseListThunk",
  endpoint: "/expenses/findAll",
  method: "POST",
  useHandleSearch: true, // ✅ If you want to support global search
  transformResponse: (response) =>
    response?.response?.map((expense) => ({
      key: expense?._id,
      departmentID: `${expense.departmentID?.name} - ${expense.departmentID?.code}`,
      code: expense.code,
      clientName: expense.clientName,
      companyName: expense.companyName,
      approvers: expense.approvers,
      status: expense.status,
      createdAt: expense.createdAt,
      updatedAt: expense.updatedAt,
    })) || [],
});

export const addOrDraftExpenseThunk = createDynamicThunk({
  typePrefix: "expenses/addOrDraftExpenseThunk",
  endpoint: "/pending-requests",
  method: "POST",
  refreshList: true,
  listThunk: getExpenseListThunk, // auto-refresh after adding
});

export const getAdminApproverListThunk = createDynamicThunk({
  typePrefix: "users/getAdminApproverListThunk",
  endpoint: "/findUserByExpenseCategory",
  method: "POST",
  transformResponse: (response) => {
    return Array.isArray(response)
      ? response.map((user) => ({
          label: user?.name,
          value: user?._id,
        }))
      : [];
  },
});

export const getBlockedDateThunk = createDynamicThunk({
  typePrefix: "expenseCalendarControls/getBlockedDateThunk",
  endpoint: "/expCal",
  method: "POST",
  useHandleSearch: false,
});
